import { render } from "./MInputFrame.vue?vue&type=template&id=7ee521f5&scoped=true"
import script from "./MInputFrame.vue?vue&type=script&lang=js"
export * from "./MInputFrame.vue?vue&type=script&lang=js"

import "./MInputFrame.vue?vue&type=style&index=0&id=7ee521f5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ee521f5"]])

export default __exports__